import React from 'react';
// import highlightText from './HighLightText';
interface propsType  { 
  text: string,
  keyword:string
}
 const HighlightKeyWord = (props: propsType) => { 
  const { text, keyword } = props;
   const conbinedHTML = highlightText({text, keyword});
  return (
    <span
      dangerouslySetInnerHTML={{__html: String(conbinedHTML)}}
    ></span>
  );
 }

 function highlightText (props:any):string  {
  const { text, keyword, options = {
    className: 'keyword-cls',
    tagName: 'span',
  } } = props;

  if (!keyword) return text;
  const { tagName, className } = options;
  const classString = className ? ` class=${className}` : '';
  const keywordTag = `<${tagName}${classString}>${keyword}</${tagName}>`;
  let keywordText;
  let imgList:any = /<img[^>]*>/g.exec(text);
  let replaceList = text.split(/<img[^>]*>/g);
  keywordText = replaceList[0].split(keyword).join(keywordTag);

  for (var i = 1; i < replaceList.length; i++) {
    let keyText = replaceList[i].split(keyword).join(keywordTag);
    keywordText += imgList[i - 1] + keyText;
  }
  return keywordText;
}
 
export default HighlightKeyWord;

